interface FiltrosState {
  texto: string;
}

type FiltrosActionTypes = 'setSearch';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value: string;
}

export const filtrosInitialState: FiltrosState = {
  texto: '',
};

export const filtrosReducer = (
  state: FiltrosState,
  action: FiltrosAction
): FiltrosState => {
  switch (action.type) {
    case 'setSearch':
      return { ...state, texto: action.value };
    default:
      return state;
  }
};
